import React from 'react';
import CategoryCard, { Category } from './CategoryCard';
import CategoryList from './CategoryList';

interface CategoryDisplayProps {
  categories: Category[];
  selectedCategories: Category[];
  onToggle: (category: Category) => void;
  shouldShowReadMore: (text: string) => boolean;
  onReadMore: (id: string) => void;
  nodeData: any;
}

const CategoryDisplay: React.FC<CategoryDisplayProps> = ({
  categories,
  selectedCategories,
  onToggle,
  shouldShowReadMore,
  onReadMore,
  nodeData
}) => {

  // Extract settings from nodeData or use defaults
  const settings = nodeData?.settings || {
    displayMode: 'cards',
    showImages: true,
    showDescriptions: true,
    displayStyle: 'card',
    itemsPerRow: 2,
    numberRows: 2,
    colors: {}
  };

  // Extract colors from settings
  const colors = settings?.colors || {};

  // Function to calculate grid columns based on itemsPerRow
  const getGridClass = (itemsPerRow: number) => {
    switch (itemsPerRow) {
      case 1:
        return 'lp-grid-cols-1';
      case 2:
        return 'lp-grid-cols-1 md:lp-grid-cols-2';
      case 3:
        return 'lp-grid-cols-1 md:lp-grid-cols-2 lg:lp-grid-cols-3';
      case 4:
        return 'lp-grid-cols-1 md:lp-grid-cols-2 lg:lp-grid-cols-4';
      default:
        return 'lp-grid-cols-1 md:lp-grid-cols-2';
    }
  };

  // Determine which component to render based on displayStyle/displayMode
  if (settings.displayMode === 'list' || settings.displayStyle === 'list') {
    return (
      <CategoryList
        categories={categories}
        selectedCategories={selectedCategories}
        onToggle={onToggle}
        colors={colors}
      />
    );
  } else {
    // For 'cards' mode or any other mode
    return (
      <div className={`lp-grid lp-gap-4 ${getGridClass(settings.itemsPerRow || 2)}`}>
        {categories.map(category => (
          <CategoryCard
            key={category.id}
            category={category}
            isSelected={selectedCategories.some(c => c.id === category.id)}
            onToggle={onToggle}
            shouldShowReadMore={shouldShowReadMore}
            onReadMore={onReadMore}
            colors={colors}
            showDescriptions={settings.showDescriptions}
            showImages={settings.showImages}
          />
        ))}
      </div>
    );
  }
};

export default CategoryDisplay;
